'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

const DiscussionEmbed = dynamic(() => import('disqus-react').then((mod) => mod.DiscussionEmbed), {
    ssr: false,
});

export default function Comments() {
    const pathname = usePathname();
    const baseUrl = 'https://www.formatchamp.com';
    const containerRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const node = containerRef.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0]?.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '200px' }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <div ref={containerRef} className="w-full max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto my-8">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 text-center">
                Have suggestions or feedback? We&apos;re constantly improving FormatChamp based on your comments.
            </p>
            {isVisible && (
                <DiscussionEmbed
                    shortname="formatchamp"
                    config={{
                        url: `${baseUrl}${pathname}`,
                        identifier: pathname,
                        title: `FormatChamp - ${pathname.slice(1).charAt(0).toUpperCase() + pathname.slice(2)}`,
                    }}
                />
            )}
        </div>
    );
}
